<mat-icon matTooltip="{{ 'GridTable.Filter.FilterText' | translate }}" [matMenuTriggerFor]="menu">filter_alt</mat-icon>
<mat-menu #menu="matMenu" class="p-3">
  <form [formGroup]="filterForm" (click)="$event.stopPropagation();">
    <div class="col">
      <mat-form-field>
        <mat-label>{{ 'GridTable.Filter.FilterType' | translate }}</mat-label>
        <mat-select [formControl]="filterTypeControl" [value]="filterTypeControl"
                    (selectionChange)="onFilterChange($event)">
          <mat-option *ngFor="let option of filterOptions" [value]="option.value">
            {{ option.translationKey | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>
  <form [formGroup]="stringForm" (click)="$event.stopPropagation();">
    <div class="col">
      <mat-form-field>
        <mat-label>{{'GridTable.Filter.Text' | translate }} </mat-label>
        <input type="text" autocompleteOff matInput [formControl]="stringControl">
      </mat-form-field>
    </div>
  </form>
  <div class="col" style="display: flex; justify-content: flex-end;">
    <mat-icon matTooltip="{{ 'GridTable.Filter.Cancel' | translate }}" style="cursor: pointer;" color="primary"
              (click)="onCancel()">
      clear
    </mat-icon>
    <mat-icon matTooltip="{{ 'GridTable.Filter.ApplyFilter' | translate }}" style="cursor: pointer;" color="primary"
              (click)="onSubmit($event)">
      check
    </mat-icon>
    <mat-icon matTooltip="{{ 'GridTable.Filter.Clear' | translate }}" style="cursor: pointer;" color="primary"
              *ngIf="this.currentValue | async" (click)="onClear()">
      delete
    </mat-icon>
  </div>
</mat-menu>
